import classNames from 'classnames';

import { tooltipJSON } from 'components/TooltipIcon/tooltipJSON';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import Popover from '@lotlinx-aws/sparky-component-library/Sparky/Popover';
import { InfoIcon } from '@lotlinx-aws/sparky-component-library/Sparky/SVGs/InfoIcon';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import Tooltip from '@lotlinx-aws/sparky-component-library/Sparky/Tooltip';

import styles from './TooltipIcon.module.scss';

export interface ToolipIconProps {
  // for searching file tooltipJSON.ts
  textKey?: string;
  // manually set tooltip text
  tipText?: string;
  side?: 'left' | 'right' | 'top' | 'bottom';
  className?: string;
  usePopover?: boolean;
  title?: string;
}

/**
 * TooltipIcon
 */
export default function TooltipIcon({
  textKey,
  tipText,
  side = 'bottom',
  className,
  usePopover = false,
  title,
}: ToolipIconProps) {
  let text;
  if (textKey) {
    const tooltipItem = tooltipJSON.find((item) => item.key === textKey);
    text = tooltipItem?.Tooltip ?? '';
  } else {
    text = tipText ?? '';
  }

  if (usePopover) {
    return (
      <div className={classNames([styles.tooltipicon, className])}>
        <Popover
          side={side}
          verticalOffset={12}
          horizontalOffset={-25}
          showCloseButton={false}
          align='end'
          isHoverTriggered
          popupContent={
            <div className={styles.popoverContainer}>
              {title && (
                <Text lineHeight='24px' color='secondary' fontWeight={5}>
                  {title}
                </Text>
              )}
              <Text size='14'>{tipText}</Text>
            </div>
          }
        >
          <Flex alignItems='center' justifyContent='center'>
            <InfoIcon />
          </Flex>
        </Popover>
      </div>
    );
  }

  return (
    <div className={classNames([styles.tooltipicon, className])}>
      <Tooltip side={side} content={text}>
        <div>
          <InfoIcon />
        </div>
      </Tooltip>
    </div>
  );
}

export function getTooltipDefByKey(textKey: string) {
  return tooltipJSON.find((item) => item.key === textKey)?.Description ?? '';
}
